import React, { useState,useEffect } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "lucide-react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { FaCopy, FaFileCsv, FaFileExcel, FaFilePdf } from 'react-icons/fa';
import axios from "axios";
import { BaseUrl } from "../App";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const EditCustomer = () => {
  const [customerDetails, setCustomerDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [bookingDetails, setBookingDetails] = useState([ ]);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [selectedValue, setSelectedValue] = useState(10);
  const [currentPage, setCurrentPage] = useState(1); // Pagination state
  const [entriesPerPage, setEntriesPerPage] = useState(10); // Number of entries per page
  const [searchQuery, setSearchQuery] = useState("");
  const [successMessage, setSuccessMessage] = useState("")
  
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };
  
  // Filter customerDetails based on search query
  const filteredCustomerDetails = customerDetails.filter((customer) => {
    const fullName = `${customer.first_name} ${customer.last_name}`.toLowerCase();
    const email = customer.user_email.toLowerCase();
    const phone = customer.phone.toLowerCase();
  
    return (
      fullName.includes(searchQuery) ||
      email.includes(searchQuery) ||
      phone.includes(searchQuery)
    );
  });
  const handleInputChange = (e) => {
    setCustomerDetails({
      ...customerDetails,
      [e.target.name]: e.target.value,
    });
  };

  const saveDetails = () => {
    console.log("Details saved");
  };

  const handleExcelExport = () => {
    const columns = [
      "Name",
      "Email",
      "Phone",
      "City",
      "State",
      "Notes",
    ];
  
    const rows = customerDetails.map((row) => [
      `${row.first_name} ${row.last_name}`,
      row.user_email,
      row.phone,
      row.city,
      row.state,
      row.notes,
    ]);
  
    const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Customer Data");
    XLSX.writeFile(wb, "customer-data.xlsx");
  };
  
     const handleCopy = () => {
    // Collect the data from the table
    const tableContent = customerDetails
      .map((row) => {
        return [
          row.user_email,
          row.phone,
          row.city,
          row.state,
          row.notes,
         
        ];
      })
      .join("\n");  // Join each row with a newline for better readability
  
    // Check if Clipboard API is supported
    if (navigator?.clipboard) {
      // Use Clipboard API if available
      navigator.clipboard.writeText(tableContent)
        .then(() => {
          alert("Table data copied to clipboard!");
        })
        .catch((error) => {
          console.error("Error copying to clipboard: ", error);
          alert("Failed to copy data. Please try again.");
        });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = tableContent;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        alert("Table data copied to clipboard!");
      } catch (err) {
        console.error("Error using execCommand: ", err);
        alert("Failed to copy data. Please try again.");
      }
      document.body.removeChild(textArea);  // Remove the textarea after copying
    }
  };
  
  const handlePdfExport = () => {
    const doc = new jsPDF();
    
    const columns = [
      "Name",
      "Email",
      "Phone",
      "City",
      "State",
      "Notes",
    ];
  
    // Mapping the rows correctly
    const rows = customerDetails.map((row) => [
      `${row.first_name} ${row.last_name}`, // Combine first and last name
      row.user_email,
      row.phone,
      row.city,
      row.state,
      row.notes,
    ]);
  
    // Generating the PDF using jsPDF autoTable plugin
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 20,
      theme: "grid",
      margin: { horizontal: 10 },
      headStyles: {
        fillColor: [0, 123, 255],
        textColor: 255,
      },
    });
  
    // Save the generated PDF with a file name
    doc.save("customer-details.pdf");
  };

  const handleCsvExport = () => {
    const csvData = customerDetails.map((row) => [
      `${row.first_name} ${row.last_name}`,
      row.user_email,
      row.phone,
      row.city,
      row.state,
      row.notes,
    ]);
  
    const csvContent = `data:text/csv;charset=utf-8,${csvData.join("\n")}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "customer-data.csv");
    link.click();
  };
  

  // Pagination logic
  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const handlePageChange = (page) => setCurrentPage(page);

  const startIndex = (currentPage - 1) * entriesPerPage;
  const filteredData = bookingDetails; // Assuming no filtering for simplicity
  const paginatedData =
    entriesPerPage === "All"
      ? filteredData
      : filteredData.slice(startIndex, startIndex + entriesPerPage);

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const indexOfLastItem = currentPage * selectedValue;
  const indexOfFirstItem = indexOfLastItem - selectedValue;
  const currentPageData = bookingDetails.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
    // Fetch customer data on component mount
    useEffect(() => {
      const fetchCustomerData = async () => {
        setLoading(true);
        try {
          const response = await axios.post(
            `${BaseUrl}/backend/api/customer_list.php`, // Replace with actual API URL
            {
              action: "all_customer_list", // Action for fetching all customer data
              api_key: "1", // Replace with actual API key
            }
          );
  
          if (response.data.status === "true") {
            setCustomerDetails(response.data.response); 
            console.log("Api Response",response.data.response)// Update state with customer data
          } else {
            setError(response.data.response || "Failed to load customers.");
          }
        } catch (error) {
          setError("An error occurred while fetching customer data.");
          console.error("API error:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchCustomerData(); // Call the function to fetch customer data
    }, []);
  
    // Loading state
    // if (loading) return <p>Loading...</p>;
  
    // Error state
    if (error) return <p>{error}</p>;

  return (
  
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="container mx-auto px-4 md:px-6 lg:px-8  xl:px-24 py-6 ">
      <h1 className="text-3xl font-semibold text-blue-600 mb-6">
        Customer Detail
      </h1>

      <div className="p-6 font-sans flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0 sm:space-x-4">
  {/* Search Bar */}
  <div className="flex items-center w-full sm:w-auto">
    <label className="block text-lg font-medium mb-2 sm:mb-0">
      Search:
      <input
        type="search"
        placeholder="Search by Name, Email or Phone"
        className="mt-2 p-2 w-full sm:w-48 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm"
        onChange={handleSearch}
      />
    </label>
  </div>

  {/* Export Buttons */}
  <div className="flex flex-wrap justify-center sm:justify-start items-center gap-4 sm:gap-6 md:gap-8 px-2 sm:px-4 w-full sm:w-auto">
    <button
      className="bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold text-sm sm:text-base py-1 sm:py-2 px-2 sm:px-4 rounded-full shadow-lg hover:shadow-xl hover:from-green-600 hover:to-green-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
      onClick={handleCopy}
    >
      <FaCopy className="text-sm sm:text-lg" />
      Copy
    </button>

    <button
      className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-white font-semibold text-sm sm:text-base py-1 sm:py-2 px-2 sm:px-4 rounded-full shadow-lg hover:shadow-xl hover:from-yellow-600 hover:to-yellow-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
      onClick={handleCsvExport}
    >
      <FaFileCsv className="text-sm sm:text-lg" />
      CSV
    </button>

    <button
      className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-sm sm:text-base py-1 sm:py-2 px-2 sm:px-4 rounded-full shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
      onClick={handleExcelExport}
    >
      <FaFileExcel className="text-sm sm:text-lg" />
      Excel
    </button>

    <button
      className="bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold text-sm sm:text-base py-1 sm:py-2 px-2 sm:px-4 rounded-full shadow-lg hover:shadow-xl hover:from-red-600 hover:to-red-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
      onClick={handlePdfExport}
    >
      <FaFilePdf className="text-sm sm:text-lg" />
      PDF
    </button>
  </div>

  {/* Dropdown for Entries */}
  <div className="flex items-center w-full sm:w-auto">
    <label htmlFor="time-dropdown" className="text-lg font-medium mr-2">
      Show
      <select
        id="time-dropdown"
        value={selectedValue}
        onChange={handleChange}
        className="ml-2 p-2 text-sm border rounded-md focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
      >
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>
      entries
    </label>
  </div>
</div>

      <div className="overflow-x-auto sm:overflow-visible">
  {/* Table Layout (visible on tablets or larger screens) */}
  <div className="hidden sm:block">
    <table className="min-w-full table-auto border-collapse border border-gray-300">
      <thead>
        <tr className="bg-gray-100">
          <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">Id</th>
          <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">Name</th>
          <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">Email</th>
          <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">Phone</th>
          <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">Address</th>
          <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">City</th>
          <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">State</th>
          <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">Notes</th>
        </tr>
      </thead>
      <tbody>
        {filteredCustomerDetails.map((customer, index) => (
          <tr key={index} className="border-t border-gray-200">
            <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{customer.id}</td>
            <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{customer.first_name} {customer.last_name}</td>
            <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{customer.user_email}</td>
            <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{customer.phone}</td>
            <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{customer.address}</td>
            <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{customer.city}</td>
            <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{customer.state}</td>
            <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{customer.notes}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card Layout (visible on small screens) */}
  <div className="sm:hidden">
    {filteredCustomerDetails.map((customer, index) => (
      <div key={index} className="bg-white shadow-lg rounded-md p-4 mb-4 border border-gray-300">
        <div className="flex justify-between mb-2">
          <span className="font-bold text-gray-900">Id:</span>
          <span>{customer.id}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="font-bold text-gray-900">Name:</span>
          <span>{customer.first_name} {customer.last_name}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="font-bold text-gray-900">Email:</span>
          <span>{customer.user_email}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="font-bold text-gray-900">Phone:</span>
          <span>{customer.phone}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="font-bold text-gray-900">Address:</span>
          <span>{customer.address}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="font-bold text-gray-900">City:</span>
          <span>{customer.city}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="font-bold text-gray-900">State:</span>
          <span>{customer.state}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-bold text-gray-900">Notes:</span>
          <span>{customer.notes}</span>
        </div>
      </div>
    ))}
  </div>
</div>

      <span className="text-sm  mt-2  text-gray-600">
        Showing {indexOfFirstItem + 1} to{" "}
        {Math.min(indexOfLastItem, bookingDetails.length)} of{" "}
        {bookingDetails.length} entries
      </span>

      {entriesPerPage !== "All" && (
        <div className="flex items-center  justify-end mt-3">
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
          >
            Previous
          </button>
          {[...Array(totalPages).keys()].map((page) => (
            <button
              key={page + 1}
              onClick={() => handlePageChange(page + 1)}
              className={`px-4 py-2 border ${
                currentPage === page + 1
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              {page + 1}
            </button>
          ))}
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
    
  </div>
  );
};

export default EditCustomer;

